import React from 'react';
import { StyleSheet, Text, TouchableOpacity, ActivityIndicator } from 'react-native';
import { colors, useTheme } from './theme';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 18,
    height: 48,
    borderRadius: 24,
    borderWidth: 1
  }
});

interface Props {
  title: string;
  onPress: () => void;
  colorScheme?: 'yellow' | 'blue';
  loading?: boolean;
}

const getColors = (scheme: Props['colorScheme'], loading: boolean) => {
  // If loading, we make the text color transparent.
  // This maintains the width of the button when the loader is displayed
  switch (scheme) {
    case 'yellow':
    default:
      return {
        backgroundColor: colors.white,
        borderColor: colors.yellow,
        fontColor: loading ? 'transparent' : colors.night,
        loader: colors.night
      };
    case 'blue':
      return {
        backgroundColor: colors.white,
        borderColor: colors.night,
        fontColor: loading ? 'transparent' : colors.night,
        loader: colors.night
      };
  }
};

const OutlineButton = (props: Props) => {
  const { title, onPress, colorScheme = 'yellow', loading = false } = props;
  const colorPalette = getColors(colorScheme, loading);
  const {
    fonts: { sans }
  } = useTheme();
  return (
    <TouchableOpacity
      style={[
        styles.container,
        { backgroundColor: colorPalette.backgroundColor, borderColor: colorPalette.borderColor }
      ]}
      onPress={onPress}
    >
      <ActivityIndicator
        animating={loading}
        style={{ position: 'absolute' }}
        color={colorPalette.loader}
      />
      <Text style={{ fontSize: 14, color: colorPalette.fontColor, ...sans.semiBold }}>{title}</Text>
    </TouchableOpacity>
  );
};

export default OutlineButton;
